/**
* Monitor Scroll Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Monitor Scroll Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'monitor-scroll-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      $( '.monitor-scroll-content' ).each( function( key, val ) {
        const height = $( this ).outerHeight();
        const panelNum = $( this ).find( '.wysiwyg' ).length;
        const panelHeight = window.innerHeight;
        $( this ).css( 'height', panelHeight * ( panelNum ) );
        window.scrollRefreshPriority--;

        const pinner = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            pin: $( this ).find( '.inner-area' )[0],
            start: 'top top',
            end: '=+' + ( panelHeight * ( panelNum + 1 ) ),
            refreshPriority: window.scrollRefreshPriority,
            scrub: 0,
            pinSpacing: false,
            // markers: true,
          },
        } );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top top',
            end: '=+' + ( panelHeight * ( panelNum - 1 ) ),
            refreshPriority: window.scrollRefreshPriority,
            scrub: 0,
            // markers: true,
            onUpdate: ( self ) => {
              for ( let i = 1; i <= panelNum; i++ ) {
                const prevNum = i - 1;
                if ( self.progress >= ( prevNum / panelNum ) && self.progress <=( ( i + 1 ) / panelNum ) ) {
                  $( this ).find( '.wysiwyg' ).not( ':nth-child(' + i + ')' ).removeClass( 'is-active' );
                  $( this ).find( '.wysiwyg:nth-child(' + i + ')' ).addClass( 'is-active' );
                }
              }
            },
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'monitor-scroll-content', COMPONENT );
} )( app );
